<template>
	<div v-if="$store.getters['cart/hasInvalidItems']">
		<div class="invalid text-danger mb-4 text-small">
			<i class="lnr icon-warning"></i> {{__('cart_has_unavailable_items')}}
		</div>
		<div class="buttons d-flex mb-2">
			<PrimaryButton class="btn-red flex-fill" @click="$store.dispatch('cart/deleteInvalidItems')">
				<i class="lnr icon-trash"></i>
				{{__('delete_unavailable_items')}}
			</PrimaryButton>
		</div>
	</div>
</template>

<script>
import PrimaryButton from '@/Components/PrimaryButton.vue';
export default {
	name: "InvalidItemsResolver",
	components : {
		PrimaryButton
	}
}
</script>

<style scoped>

</style>